import type { ICard } from "../../cardsSlice";

export const major9Card: ICard = {
    id: "major_9",
    arcana: "major",
    number: 9,
    suit: "major",
    court: "major",
    name: "Отшельник",
    nameEn: "The Hermit",
    keywords: ["Уединение", "Поиск истины", "Внутренняя мудрость"],
    symbolism: ["Старец с фонарём и посохом", "Серое одеяние", "Заснеженные вершины"],
    symbolismInterpretation:
      "Олицетворяет внутреннее исследование, удаление от мира ради истины и понимания",
    archetype: "Мудрец, внутренний путеводитель, архетип самопознания",
    psychology: "Потребность в тишине, рефлексия, сосредоточенность на внутреннем пути",
    upright: {
      personality: "Вдумчивость, самоконтроль, зрелость",
      relationships: "Дистанция, потребность в личном пространстве",
      work: "Исследование, наставничество, анализ",
      spirituality: "Поиск смысла, внутренняя работа",
      examples: ["Отказ от суеты", "Период самоанализа", "Желание уединения"]
    },
    reversed: {
      meaning: "Изоляция, уход от реальности, одиночество",
      nuances: "Замкнутость, отчуждение, потеря связи с внешним миром"
    },
    associations: ["Фонарь", "Путь", "Тишина", "Внутренний голос"],
    combinations: ["С Иерофантом — духовное руководство", "С Луной — погружение в теневые аспекты"],
    readingTips: ["Проверить, не чрезмерно ли уединение", "Оценить, чему служит отстранение"],
    selfQuestions: ["Чего я ищу?", "Почему мне важно уединение?"]
  };


